export default __webpack_public_path__ + "static/media/userSettingsProfile.c8eb425a.svg";